import { withTranslation } from '@application/i18n/with_translation';
import { Button, ButtonProps } from '@cellula/react';
import { Auth } from './auth.component';

interface AuthSignInButtonProps {
	returnUrl?: string;
}

export function AuthSignInButton({ returnUrl = window.location.href }: AuthSignInButtonProps) {
	return (
		<Auth.SignInSheet
			returnUrl={returnUrl}
			trigger={
				<Button variant='primary' size='medium' icon='login'>
					{withTranslation('Common.Button.SignIn')}
				</Button>
			}
		/>
	);
}
